/**
 * "Nothing" arrives in several shapes: a field absent from an object is
 * `undefined`, a cleared one is `null`, a blank text input is `''`, and an
 * un-added list is `[]`. A `.length`/truthy check on the raw value doesn't
 * see that a `dateInputConfig.hours` of `[]` - the schema default for a
 * plain, non-booking date input - is "not configured", while `{}` or `42`
 * (never a legal shape) would slip past a `.length` check unnoticed.
 * Mirrors UtilsService.isBlankValue on the API.
 */
export function isBlankValue(value: any): boolean {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0)
  );
}
